<script setup lang="ts">
import { UiAsset } from '~/components/ui'
import * as Hospitality from '~/assets/hospitality'
</script>

<template>
  <section id="hospitality" class="relative py-16">
    <svg class="absolute top-0 right-0 opacity-10" width="200" height="100" fill="none" viewBox="0 0 200 100">
      <defs>
        <pattern id="d3eb07ae-5182-43e6-857d-35c643af9035" x="0" y="0" width="20" height="200" patternUnits="userSpaceOnUse">
          <line class="text-primary-500" stroke="currentColor" x1="0" y1="0" x2="0" y2="200" stroke-width="6" />
        </pattern>
      </defs>
      <rect width="200" height="100" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9035)" />
    </svg>
    <svg class="absolute bottom-0 left-0 opacity-10 rotate-90 origin-top" width="200" height="100" fill="none" viewBox="0 0 200 100">
      <rect width="200" height="100" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9035)" />
    </svg>

    <div class="max-w-7xl mx-auto px-4 relative">
      <div class="max-w-xl mb-12">
        <span class="font-semibold text-accent-500 tracking-wider uppercase">
          {{ $t('pages.index.hospitality.suptitle') }}
        </span>
        <h2 class="font-heading mt-1 mb-5 text-2xl font-semibold text-gray-900 md:text-3xl">
          {{ $t('pages.index.hospitality.title') }}
        </h2>
        <p class="mt-4 text-gray-500 md:text-justify">
          {{ $t('pages.index.hospitality.content') }}
        </p>
      </div>

      <div class="flex space-x-4">
        <div v-for="(image, idx) in Hospitality"
             :key="idx"
             class="w-1/2 sm:w-1/3 md:w-1/4"
        >
          <div class="aspect-square rounded-lg bg-gray-100 overflow-hidden">
            <UiAsset :src="image"
                     alt="Hospitality"
                     class="object-center object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
